import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, isRef as _isRef, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "card-toolbar w-full row" }
const _hoisted_4 = { class: "p-input-icon-left ml-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "p-input-icon-left ml-4 mr-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_8 = { class: "p-input-icon-left" }
const _hoisted_9 = { class: "p-input-icon-left ml-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = { class: "card-body pt-0" }

import Column from "primevue/column";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import {ref, onMounted, watch} from "vue";
import {FilterMatchMode} from "primevue/api";
import { fetchCodesNotAvailable } from "@/_services/code/code";
import ApiService from "@/_services/api.service";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'StockCodeNotAvailableList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);

const rows = ref<number>(10);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];

const codeNameModel = ref<string>("");
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const currentPage = ref<number>(0);
let productNameModel = ref('');
let supplierModel = ref('');
let orderNumberModel = ref('');

onMounted(async () => {
  await populateDatatable();
});
async function populateDatatable() {
    let paramsFilter = {
        name: codeNameModel.value,
        supplier:supplierModel.value,
        productName: productNameModel.value,
        orderNumber: orderNumberModel.value.trim()
    };
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchCodesNotAvailable(rows.value, page.value, paramsFilter);
  isLoading.value = loadingDt.value;
  tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;

}

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};

const onFilterDt = () => {
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

watch(
    supplierModel,
    (value) => {
        onFilterDt();
    });

const onClearInputCodeName = () => {
    if (codeNameModel.value === ""  ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const onClearInputOrderNumber = () => {
    if (orderNumberModel.value === ""  ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const onClearInputProductName= () => {
    if ( productNameModel.value === "" ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};
async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      value: tableData.value,
      rows: rows.value,
      paginator: true,
      loading: isLoading.value,
      rowsPerPageOptions: rowsPerPageOptions,
      lazy: "",
      onPage: onPaginate,
      currentPage: currentPage.value,
      totalRecords: totalRecords.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(InputText), {
                modelValue: codeNameModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeNameModel).value = $event)),
                placeholder: "Rechercher un code",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputCodeName
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                modelValue: _unref(productNameModel),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(productNameModel) ? (productNameModel).value = $event : productNameModel = $event)),
                placeholder: "Rechercher par produit",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputProductName
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_FormKit, {
                type: "autocomplete",
                name: "supplier",
                placeholder: "Sélectionner un fournisseur",
                options: searchSuppliers,
                modelValue: _unref(supplierModel),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(supplierModel) ? (supplierModel).value = $event : supplierModel = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("span", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(InputText), {
                modelValue: _unref(orderNumberModel),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(orderNumberModel) ? (orderNumberModel).value = $event : orderNumberModel = $event)),
                placeholder: "Rechercher par commande",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputOrderNumber
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("Aucun résultat trouvé.")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(Column), {
            field: "code",
            header: "Code"
          }),
          _createVNode(_unref(Column), {
            field: "productName",
            header: "Nom du produit"
          }),
          _createVNode(_unref(Column), {
            field: "productType",
            header: "Type de produit"
          }),
          _createVNode(_unref(Column), {
            field: "supplierName",
            header: "Fournisseur"
          }),
          _createVNode(_unref(Column), {
            field: "saleDate",
            header: "Date de vente"
          }),
          _createVNode(_unref(Column), {
            field: "orderNumber",
            header: "Numéro de commande"
          }),
          _createVNode(_unref(Column), {
            field: "userName",
            header: "Nom du client"
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading", "currentPage", "totalRecords"])
  ]))
}
}

})